import React, { useState } from "react";
import {
  TextField,
  SxProps,
  Theme,
  Box,
  IconButton,
  InputAdornment,
  Snackbar,
  Alert,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { UserProfile } from "../../components/auth/firestore/getUserDetails";

interface ReadOnlyFieldsProps {
  userData: UserProfile | null;
  textFieldSx: SxProps<Theme>;
}

// Displays non-editable user fields, with copy feedback for referral code
const ReadOnlyFields: React.FC<ReadOnlyFieldsProps> = ({
  userData,
  textFieldSx,
}) => {
  const referralCode = userData?.referralCode || "";
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // copy referral code and show feedback
  const handleCopy = () => {
    if (referralCode) {
      navigator.clipboard.writeText(referralCode);
      setSnackbarOpen(true);
    }
  };

  const handleCloseSnackbar = (
    _?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  return (
    <>
      <Box>
        {/* Email (read-only) */}
        <TextField
          label="Email"
          variant="outlined"
          fullWidth
          value={userData?.email || ""}
          disabled
          sx={{ ...textFieldSx, marginBottom: "1rem" }}
        />

        {/* Referral Code with copy button */}
        <TextField
          label="Referral Code"
          variant="outlined"
          fullWidth
          value={referralCode}
          disabled
          sx={textFieldSx}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleCopy}
                  edge="end"
                  disabled={!referralCode}
                >
                  <ContentCopyIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {/* Copy confirmation */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          variant="filled"
          sx={{ width: "auto" }}
        >
          Referral code copied!
        </Alert>
      </Snackbar>
    </>
  );
};

export default ReadOnlyFields;
